import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import { userSelector } from '../../user/userSelectors'
import { isAffiliationLoading } from '../../../webservices/affiliation/affiliationSelector'
import { getListeDemandes, isDemandesLoading } from '../../../webservices/demandes/demandesSelectors'
import * as actionsAffiliation from '../../../webservices/affiliation/affiliationActions'
import * as demandeActions from '../../../webservices/demandes/demandesActions'
import PageLayout from '../../../../components/PageLayout'
import HistoriqueDemandes from '../components/HistoriqueDemandes'

const SuivieDemandePage = (
	{
		// @ts-ignore
		getAffiliation,
		// @ts-ignore
		getDemandes,
		// @ts-ignore
		loading,
		// @ts-ignore
		demandes,
		// @ts-ignore
		assurePrincipal,
		// @ts-ignore
		user
	}
) => {

	const intl = useIntl()

	useEffect(() => {
		getAffiliation()
		getDemandes()
	}, [getAffiliation, getDemandes])

	return (
		<PageLayout title={intl.formatMessage({ id: 'suivie_Demande.title' })} subtitle={intl.formatMessage({ id: 'suivie_Demande.subtitle' })}>
			<HistoriqueDemandes
				demandes={demandes}
				assurePrincipal={assurePrincipal}
				loading={loading}
			/>
		</PageLayout>
	)
}

const mapStateToProps = (state: any) => ({
	user: userSelector(state),
	assurePrincipal: state.affiliation.data.assurePrincipal,
	demandes: getListeDemandes(state),
	loading: isDemandesLoading(state) || isAffiliationLoading(state)
})

const actions = {
	getDemandes: demandeActions.forceGetDemandes,
	getAffiliation: actionsAffiliation.getAffiliation
}

export default connect(mapStateToProps, actions)(SuivieDemandePage)
